import React from "react";
import s from "./style.module.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";

const TestChart = (props) => {
  const { ref, width, height } = useVizualisation();

  return (
    <Vizualisation {...props} ref={ref}>
      <svg
        className={s.svg}
        width={width}
        height={props.size === "fullscreen" ? height : width * 0.25}
      ></svg>
    </Vizualisation>
  );
};

const ExampleChart = ({ data, title, note, source }) => {
  const allProps = { title, note, source };

  return (
    <>
      <TestChart {...allProps} />
      <TestChart {...allProps} size="large" />
      <TestChart {...allProps} size="xLarge" />
      <TestChart {...allProps} size="fullwidth" />
      <TestChart {...allProps} size="fullscreen" />
    </>
  );
};

export default ExampleChart;
